module.exports = __webpack_public_path__ + "media/images/bb-ea58f311cc4eeb4f2a5b965c474f6e71.webp";